import mediator from 'Utilities/mediator';
const handleLogin = request => {
  switch (request.mode) {
    case 'oauth':
      request.response = mediator.request('oauth:login', {
        ...request.values
      });
      break;
    default:
      request.response = mediator.request('user:login', {
        values: request.values
      });
      break;
  }
};
mediator.subscribe('auth:login', handleLogin);
export * from './oauth';